export const strategicImperativeFragment = `
  _id
  title
  description
  country
  therapeuticArea
  year
  updated
`;
